import { formatDate } from 'date-fns';
import { ReleaseType } from '@ibk/shared-types';
import { VoucherDiscountType, VoucherRechargeDayType, } from '../../types';
import { getUnformatedValue } from '../../utils';
export var SimulationState;
(function (SimulationState) {
    SimulationState["IDLE"] = "IDLE";
    SimulationState["SIMULATING"] = "SIMULATING";
    SimulationState["ERROR"] = "ERROR";
    SimulationState["SUCCESS"] = "SUCCESS";
})(SimulationState || (SimulationState = {}));
export var NewRechargeStepStatus;
(function (NewRechargeStepStatus) {
    NewRechargeStepStatus["INACTIVE"] = "inactive";
    NewRechargeStepStatus["ACTIVE"] = "active";
    NewRechargeStepStatus["COMPLETED"] = "completed";
})(NewRechargeStepStatus || (NewRechargeStepStatus = {}));
export var NewRechargeStep;
(function (NewRechargeStep) {
    NewRechargeStep["COMPETENCE"] = "COMPETENCE";
    NewRechargeStep["PRODUCTS"] = "PRODUCTS";
    NewRechargeStep["DELIVERY_ADDRESS"] = "DELIVERY_ADDRESS";
    NewRechargeStep["GLOBAL_SETTINGS"] = "GLOBAL_SETTINGS";
    NewRechargeStep["BENEFICIARIES_VALUES"] = "BENEFICIARIES_VALUES";
    NewRechargeStep["PAYMENT"] = "PAYMENT";
    NewRechargeStep["SUMMARY"] = "SUMMARY";
})(NewRechargeStep || (NewRechargeStep = {}));
export const mapFormDataToSimulateVoucherContractRechargeVoucherRequestDto = (formData, product, isBeneficiaryDiscountEnabled) => {
    const discountType = formData.payrollDeduction === false
        ? VoucherDiscountType.NO_DISCOUNT
        : VoucherDiscountType[formData.discountType ?? product?.discountType ?? VoucherDiscountType.NO_DISCOUNT];
    let discountValue;
    if (discountType !== VoucherDiscountType.NO_DISCOUNT && formData.payrollDeduction !== false) {
        if (formData.discountValue) {
            discountValue = getUnformatedValue(formData.discountValue);
        }
        else {
            discountValue = product?.discountValue;
        }
    }
    const rechargeDayType = VoucherRechargeDayType[formData.rechargeDayType ?? product?.rechargeDayType ?? VoucherRechargeDayType.FIRST_WORKING_DAY];
    const rechargeDay = rechargeDayType === VoucherRechargeDayType.FIXED_DAY ? (formData.rechargeDay ?? product?.rechargeDay) : null;
    const creditDate = formData.creditDate ? formatDate(formData.creditDate, 'yyyy-MM-dd') : undefined;
    const releaseType = ReleaseType[formData.releaseType ?? product?.releaseType ?? ReleaseType.MONTHLY];
    const shouldIncludeDiscountValue = isBeneficiaryDiscountEnabled && formData.isIndividualDiscount;
    let beneficiaries;
    if (formData.selectedBeneficiariesList?.length) {
        beneficiaries = (formData.selectedBeneficiariesList ?? []).map(selected => {
            const baseBeneficiary = {
                beneficiaryId: selected.beneficiaryId,
            };
            if (releaseType === ReleaseType.DAILY) {
                baseBeneficiary.daysQuantity = selected.daysQuantity;
            }
            else {
                baseBeneficiary.value = selected.value;
            }
            if (shouldIncludeDiscountValue && selected.discountValue !== undefined) {
                baseBeneficiary.discountValue = selected.discountValue;
            }
            return baseBeneficiary;
        });
    }
    const basePayload = {
        voucherTypeId: formData.voucherTypeId ?? product?.voucherType,
        discountType,
        discountValue,
        rechargeDayType,
        rechargeDay,
        creditDate,
        releaseType,
        beneficiaries,
    };
    if (isBeneficiaryDiscountEnabled) {
        basePayload.isIndividualDiscount = formData.isIndividualDiscount ?? false;
    }
    if (releaseType === ReleaseType.DAILY) {
        return {
            ...basePayload,
            amountDaily: formData.amountDaily ?? product?.amountDaily,
        };
    }
    return basePayload;
};
